import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import { DialogTitle } from '@mui/material';
import useHooks from 'src/hooks/useHooks';
import usePost from 'src/hooks/usePost';
import { useDispatch } from 'react-redux';
import { logOut } from 'src/store/auth';

export default function LogoutModal({ open, onClose }) {
    const { navigate } = useHooks()
    const { mutate } = usePost()
    const dispatch = useDispatch()
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="responsive-dialog-title"
        >
            <DialogTitle id="responsive-dialog-title">
                {"Rostdan ham chiqmoqchimisiz?"}
            </DialogTitle>
            <DialogActions>
                <Button autoFocus onClick={onClose}>
                    Bekor qilish
                </Button>
                <Button style={{ color: "red" }} onClick={() => {
                    mutate({
                        url: "user/logout",
                        method: "post",
                        data: {}
                    }, {
                        onSuccess: () => {
                            dispatch(logOut())
                            navigate('/')
                            onClose()
                        }
                    })
                }}>
                    Chiqish
                </Button>
            </DialogActions>
        </Dialog>
    );
}
